
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
    selector: 'app-main-transfer-question',
    templateUrl: './main-transfer-question.component.html',
    styleUrls: ['./main-transfer-question.component.scss'],
    animations: [
        trigger('fadeInOutAnim', [
            state('initial', style({opacity: '0'})),
            state('final', style({opacity: '1'})),
            transition('initial=>final', animate('0.5s ease-in-out')),
            transition('final=>initial', animate('0.5s ease-in-out')),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
})

export class MainTransferQuestionComponent  implements OnInit {
    public openYoutubeDialog = false;

    @Input() public productAreaOrigin: string;
    @Input() public status: string;

    constructor(private store: Store<AppState>) {}

    ngOnInit(): void {
        this.openYoutubeDialog = false;
    }

    public openYoutubeDialogReceiver(value: boolean) {
        this.openYoutubeDialog = value;
    }

    public closeYoutubeDialogReceiver(value: boolean) {
        this.openYoutubeDialog = value;
    }

    public openYoutube() {
        this.openYoutubeDialog = true;
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events: {
                    'Product Area Origin': this.productAreaOrigin,
                    'Status': this.status,
                    'Element': 'Vídeo Quanto devo transferir',
                    'Group': 'Quanto devo transferir para começar a investir?',
                    'Time Responsável': 'Sky',
                },
            },
        });
    }

}
